import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import {
    CmpsButtonModule,
    CmpsIconModule,
    CmpsScrollbarModule,
    CmpsUserInfoModule,
} from '@cmps/ng-uikit';

import { CmpsCoachingTeamschatDialogModule } from '../coaching/detail/teamschat-dialog/teamschat-dialog.module';
import { CmpsCoachingTeamschatTranscriptDialogModule } from '../coaching/detail/teamschat-dialog/teamschat-transcript-dialog/teamschat-transcript-dialog.module';
import { CmpsCoachingBehaviourSelectionDialogModule } from '../coaching/transcript-dialog/component/behaviour-selection-dialog/behaviour-selection-dialog.module';
import { CmpsTranscriptDialogModule } from '../coaching/transcript-dialog/transcript-dialog.module';
import { CmpsLazyRouterModule } from '../route.module';
import { MsalService } from '../teams-call';

import { CoachingDetailComponent } from './coaching-detail.component';
import { CoachingDetailRoutes } from './coaching-detail.route';
import { CmpsCoachingDetailPillarOneModule } from './pillar-one';
import { CmpsCoachingDetailPillarThreeModule } from './pillar-three';
import { CmpsCoachingDetailPillarTwoModule } from './pillar-two';

@NgModule({
    declarations: [CoachingDetailComponent],
    imports: [
        CmpsButtonModule,
        CmpsCoachingBehaviourSelectionDialogModule,
        CmpsCoachingDetailPillarOneModule,
        CmpsCoachingDetailPillarThreeModule,
        CmpsCoachingDetailPillarTwoModule,
        CmpsCoachingTeamschatDialogModule,
        CmpsTranscriptDialogModule,
        CmpsCoachingTeamschatTranscriptDialogModule,
        CmpsIconModule,
        CmpsLazyRouterModule.forChild(CoachingDetailRoutes),
        CmpsScrollbarModule,
        CommonModule,
        CmpsUserInfoModule,
    ],
    providers: [MsalService],
})
export class CmpsCoachingDetailModule {}
